<template>
  <div>
    <ResendConfirmationOptions
      v-if="showResendOptions"
      @startResendCounter="startResendCounter"
    />

    <div v-else>
      <div class="warning-box">
        <exclamation-circle-icon size="24" color="#92400E" />
        <p class="body-regular yellow-800">
          Esta etapa só pode ser realizada através do celular cadastrado.*
        </p>
      </div>

      <p class="body-regular gray-900 mt-20">
        Para prosseguir, acesse o link enviado para o celular:
      </p>

      <div class="phone-box">
        <p>{{ hiddenPhone }}</p>
      </div>

      <div class="resend-text">
        <a @click="resendConfirmationCode" :class="{ 'disabled': chosenConfirmationResendType }">
          Não recebi o link {{ resendCounter !== 0 ? `(${resendCounter}s)` : '' }}
        </a>
      </div>

      <div class="extra-info">
        <p class="pb-8">
          *Somente para sua primeira compra com o Parcelex é necessário fazer o envio da selfie e
          documentos através do seu celular cadastrado.
        </p>
        <p>
          Também é necessário refazer o envio caso você troque o número do seu celular.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from '@vue-hero-icons/outline';
import { mapActions, mapMutations, mapState } from 'vuex';
import ResendConfirmationOptions from './ResendConfirmationOptions.vue';

export default {
  name: 'OnboardingConfirmationLink',
  data() {
    return {
      resendCounter: 90,
    };
  },
  props: {
    hiddenPhone: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('onboardingV2', [
      'showResendOptions',
      'confirmationResendType',
      'chosenConfirmationResendType',
    ]),
  },
  methods: {
    async resendConfirmationCode() {
      if (this.resendCounter !== 0) return;
      if (!this.chosenConfirmationResendType) {
        this.setShowResendOptions({ showResendOptions: true });
        this.resendCounter = 90;
      }
    },
    startResendCounter() {
      const resendInterval = setInterval(() => {
        this.resendCounter -= 1;
        if (this.resendCounter === 0) {
          clearInterval(resendInterval);
          this.setChosenConfirmationResendType();
        }
      }, 1000);
    },
    ...mapActions('onboardingV2', [
      'setShowResendOptions',
    ]),
    ...mapMutations('onboardingV2', [
      'setChosenConfirmationResendType',
      'setDisableTheResendCounter',
    ]),
  },
  components: {
    ExclamationCircleIcon,
    ResendConfirmationOptions,
  },
  mounted() {
    this.setChosenConfirmationResendType();
    this.startResendCounter();
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

  .warning-box {
    display: flex;
    justify-content: center;
    gap: 15px;
    background-color: $yellow-100;
    border-radius: 6px;
    padding: 16px;
    margin-top: 24px;
  }

  .phone-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 26px;

    p {
      font-family: Usual;
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      color: $gray-900;
      border-radius: 6px;
      background-color: $gray-100;
      padding: 6px 12px;
    }
  }

  .resend-text {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    a {
      @extend .body-regular;
      cursor: pointer;
      color: $primary-500;

      &:hover {
        color: $primary-600;
      }

      &.disabled {
        pointer-events: none;
        color: $gray-400;
      }
    }
  }

  .extra-info {
    font-family: Usual;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: $gray-500;
    margin: 36px 0;
  }

  .pb-8 {
    padding-bottom: 8px;
  }
</style>
